import { render, staticRenderFns } from "./create.vue?vue&type=template&id=d2b98cd8&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=d2b98cd8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b98cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2b98cd8')) {
      api.createRecord('d2b98cd8', component.options)
    } else {
      api.reload('d2b98cd8', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=d2b98cd8&scoped=true", function () {
      api.rerender('d2b98cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/area/create.vue"
export default component.exports